export const UPDATE_PAGINATION_TOTAL_TEMPLATE: string = "UPDATE_PAGINATION_TOTAL_TEMPLATE";
export const UPDATE_PAGINATION_POSTS_PER_PAGE_TEMPLATE: string = "UPDATE_PAGINATION_POSTS_PER_PAGE_TEMPLATE";
export const UPDATE_PAGINATION_CURRENT_PAGE_TEMPLATE: string = "UPDATE_PAGINATION_CURRENT_PAGE_TEMPLATE";
export const UPDATE_LOADING_STATE_TEMPLATE: string = "UPDATE_LOADING_STATE_TEMPLATE";
export const UPDATE_NOTFOUND_STATE_TEMPLATE: string = "UPLOAD_NOTFOUND_STATE_TEMPLATE";
export const UPDATE_TABLE_STATE_TEMPLATE: string = "UPDATE_TABLE_STATE_TEMPLATE";
export const UPDATE_SEARCH_TEMPLATE: string = "UPDATE_SEARCH_TEMPLATE";
export const UPDATE_SEARCH_CURRENT_PAGE_TEMPLATE: string = "UPDATE_SEARCH_CURRENT_PAGE_TEMPLATE";
export const UPDATE_API_CALL_TEMPLATE: string = "UPDATE_API_CALL_TEMPLATE";

export function updateTemplatesPaginationtTotal(totalPostsTemplate: number): IUpdatePaginationTotalActionType {
    return { type: UPDATE_PAGINATION_TOTAL_TEMPLATE, totalPostsTemplate:totalPostsTemplate };
}
export function updateTemplatesPaginationtPostsPerPage(postsPerPageTemplate: number): IUpdatePaginationPostsPerPageActionType {
    return { type: UPDATE_PAGINATION_POSTS_PER_PAGE_TEMPLATE, postsPerPageTemplate:postsPerPageTemplate };
}
export function updateTemplatesPaginationcurrentPage(currentPageTemplate: number): IUpdatePaginationCurrentPageActionType {
    return { type: UPDATE_PAGINATION_CURRENT_PAGE_TEMPLATE, currentPageTemplate:currentPageTemplate };
}
export function updateTemplatesLoadingState(loadingTemplate: string): IUpdateLoadingStateActionType {
    return { type: UPDATE_LOADING_STATE_TEMPLATE, loadingTemplate:loadingTemplate };
}
export function updateTemplatesNFState(notFoundTemplate: string): IUpdateNFStateActionType {
    return { type: UPDATE_NOTFOUND_STATE_TEMPLATE, notFoundTemplate:notFoundTemplate };
}
export function updateTemplatesTableState(tableTemplate: string): IUpdateTableStateActionType {
    return { type: UPDATE_TABLE_STATE_TEMPLATE, tableTemplate:tableTemplate };
}
export function updateTemplatesSearchState(searchTemplate: string): IUpdateSearchStateActionType {
    return { type: UPDATE_SEARCH_TEMPLATE, searchTemplate:searchTemplate };
}
export function updateTemplatesSearchCurrentPageState(currentPageSearchTemplate: number): IUpdateCurrentPageSearchStateActionType {
    return { type: UPDATE_SEARCH_CURRENT_PAGE_TEMPLATE, currentPageSearchTemplate:currentPageSearchTemplate };
}
export function updateTemplatesAPICallState(apiCallTemplate: boolean): IUpdateAPICallStateActionType {
    return { type: UPDATE_API_CALL_TEMPLATE, apiCallTemplate:apiCallTemplate };
}

interface IUpdatePaginationTotalActionType { type: string, totalPostsTemplate: number}
interface IUpdatePaginationPostsPerPageActionType { type: string, postsPerPageTemplate: number}
interface IUpdatePaginationCurrentPageActionType { type: string, currentPageTemplate: number}
interface IUpdateLoadingStateActionType { type: string, loadingTemplate: string}
interface IUpdateNFStateActionType { type: string, notFoundTemplate: string}
interface IUpdateTableStateActionType { type: string, tableTemplate: string}
interface IUpdateSearchStateActionType { type: string, searchTemplate: string}
interface IUpdateCurrentPageSearchStateActionType { type: string, currentPageSearchTemplate: number}
interface IUpdateAPICallStateActionType { type: string, apiCallTemplate: boolean}